import React, { useState } from "react";
import { LuDownload } from "react-icons/lu";
import { Button, Dialog, RadioCards } from "../../components/ui";
import { SearchField } from "../../components/patterns/SearchField";
import { StepsBar } from "../../components/patterns/StepsBar";
import { HealthPlan } from "../../constants/healthPlans";
import { t } from "../../i18n";

interface HealthPlanPickerProps {
  title: string;
  plans: HealthPlan[];
  loading: boolean;
  onClose: () => void;
  onDownload: (plan: string, reportType: string) => void;
  reportType: string;
  /** Segundo passo da guia de internação (depois da descrição resumida). */
  secondStep?: boolean;
}

/** Escolha do plano de saúde (modelo da guia) e download. A busca só aparece com mais de 8 planos. */
export const HealthPlanPicker: React.FC<HealthPlanPickerProps> = ({ title, plans, loading, onClose, onDownload, reportType, secondStep }) => {
  const [plan, setPlan] = useState("");
  const [query, setQuery] = useState("");
  const q = query.trim().toLowerCase();
  const visible = plans.filter((p) => p.label.toLowerCase().includes(q));
  const label = plans.find((p) => p.value === plan)?.label;

  return (
    <Dialog
      open
      onClose={onClose}
      closeDisabled={loading}
      title={title}
      description={secondStep ? <StepsBar step={2} label={t("guides.planStep")} /> : t("guides.planHint")}
      footer={
        <>
          <Button variant="outline" onClick={onClose} disabled={loading}>
            {t("common.cancel")}
          </Button>
          <Button
            variant="primary"
            icon={<LuDownload size={18} aria-hidden />}
            loading={loading}
            disabled={!plan}
            onClick={() => onDownload(plan, reportType)}
          >
            {label ? t("guides.downloadPlan", { plan: label }) : t("guides.download")}
          </Button>
        </>
      }
    >
      <div className="flex flex-col gap-3">
        {plans.length > 8 && <SearchField value={query} onChange={setQuery} placeholder={t("guides.searchPlan")} />}
        {visible.length > 0 ? (
          <RadioCards
            label={t("guides.plan")}
            value={plan}
            onChange={setPlan}
            options={visible.map((p) => ({ value: p.value, title: p.label }))}
          />
        ) : (
          <p className="text-caption text-fg-muted">{t("guides.noPlan")}</p>
        )}
      </div>
    </Dialog>
  );
};
